import format from 'date-fns/format';
import nb from 'date-fns/locale/nb';

function capitalize(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export const formatDateAndTime = (date = new Date()) => {
  return format(new Date(date), 'PPPp', { locale: nb });
};

export const formatDateLong = (date = new Date()) => {
  return format(new Date(date), 'PPP', { locale: nb });
};

export const formatDateShort = (date = new Date()) => {
  return format(new Date(date), 'P', { locale: nb });
};

export const formatTime = (date = new Date()) => {
  return format(new Date(date), 'HH:mm', { locale: nb });
};

export const getWeekdayLong = (date = new Date(), capitalizeFirstLetter = false) => {
  const weekday = format(new Date(date), 'EEEE', { locale: nb });

  if (capitalizeFirstLetter) return capitalize(weekday);
  return weekday;
};
